import get from "lodash/get";
import {
    postInvoiceClientLoading,
    postInvoiceClientReject,
    postInvoiceClientRequest,
    postInvoiceClientSuccess,
    postInvoiceClientReset,
} from "../../actions/invoiceClient/post";

export const postInvoiceClient = (body) => async (dispatch, getState) => {
    dispatch(postInvoiceClientLoading());
    try {
        const { data } = await postInvoiceClientRequest(body, getState);
        dispatch(postInvoiceClientSuccess(data));
    } catch (error) {
        dispatch(postInvoiceClientReject(get(error, "response.data", error)));
    } finally {
        setTimeout(() => { dispatch(postInvoiceClientReset()); }, 3000);
    }
    return Promise.resolve();
};
